import React from "react";
import { useHistory, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";
import { Formik } from "formik";
import {
  Grid,
  Typography,
  Card,
  Tab,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Autocomplete,
  FormControlLabel,
  Checkbox,
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import Button from "@mui/material/Button";
import Swal from "sweetalert2";
import api from "../../../components/services/api";
import withReactContent from "sweetalert2-react-content";
import MenuItem from "@mui/material/MenuItem";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import AddIcon from "@mui/icons-material/Add";

import Select from "@mui/material/Select";
import { makeStyles } from "@mui/styles";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import LocationEmployeeTab from "./LocationEmployeeTab";
const useStyles = makeStyles({
  customOutline: {
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "red",
    },
  },
});
export default function EditLocation() {
  const classes = useStyles();
  const { id } = useParams();
  const history = useHistory();
  const [locationData, setLocationData] = useState([]);
  const [countryData, setCountryData] = useState([]);
  const [pol, setPol] = useState();
  const [CYData, setCYData] = useState([]);
  const EmpId = localStorage.getItem("EmpId");
  const [value, setValue] = useState("1");
  const [FoundStatus, setFoundStatus] = useState(false);
  const [open, setOpen] = useState(false);

  const [containerYardZoneNo, setContainerYardZoneNo] = useState("");
  const [containerYardZoneName, setContainerYardZoneName] = useState("");
  const [bayCount, setBayCount] = useState("");
  const [rowCount, setRowCount] = useState("");
  const [tireCount, setTireCount] = useState("");
  const [remark, setRemark] = useState("");
  const [rows, setRows] = useState([]);
  const [currency, setCurrency] = useState([]);
  const [MasterCost, setMasterCost] = useState([]);

  function addRow() {
    const newRow = {
      id: rows?.slice(-1)[0]?.id ? rows?.slice(-1)[0]?.id + 1 : 1,
      CostId: "",
      CostPrice: 0,
      CurrencyId: "",
      CostPerContainer: true,
    };

    setRows([...rows, newRow]);
  }
  const deletehand = (i) => {
    const data = rows?.filter((e, id) => i !== id);
    setRows(data);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const handleDisable = (index) => {
    const cyData = CYData.map((item, index2) =>
      index === index2 ? { ...item, disabled: !item.disabled } : item
    );
    setCYData(cyData);
    // console.log(props);
    // setDisableForm(true);
  };
  const FetchCountry = async () => {
    try {
      const res = await api.get("api/master/country");
      setCountryData(res.data.data);
      // console.log(data.data.data);
    } catch (e) {
      console.log(e);
    }
  };
  const getMasterCost = async () => {
    try {
      const res = await api.get(`/api/master/cost/Sale%20Order%20Cost`);
      setMasterCost(res?.data);

      //   setLog_data_length(3);
    } catch (e) {
      console.log(e);
    }
  };
  const getCurrency = async () => {
    try {
      const res = await api.get(`api/master/currency`);
      setCurrency(res?.data);

      //   setLog_data_length(3);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    FetchCountry();
    getMasterCost();
    getCurrency();
  }, [locationData]);
  const FetchCY = async () => {
    try {
      const res = await api.post("api/location/containeryard/list", {
        LocationId: id,
        Status: true,
      });

      if (res.data.length !== 0) {
        // console.log(response.data);
        setCYData(res.data);
        // console.log(Factory);

        setFoundStatus(true);
      } else {
        setFoundStatus(false);
      }
      // console.log(data.data.data);
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(() => {
    const FetchLocation = async () => {
      try {
        const res = await api.post("api/location/detail", { LocationId: id });
        setLocationData(res.data);
        setRows(res?.data?.LocationCostDetails);

        // console.log(data.data.data);
      } catch (e) {
        console.log(e);
      }
    };
    FetchLocation();

    FetchCY();
  }, [id]);

  return (
    <div>
      <Card variant="outlined" style={{ padding: "20px", margin: "25px" }}>
        <h6 style={{ marginTop: "10px" }} className="textcolorgreen">
          ตำแหน่ง
        </h6>

        <Grid
          container
          alignItems="center"
          spacing={1}
          sx={{ marginBottom: "10px" }}
        >
          <Grid item xs>
            <Typography
              className="textcolordarkblue"
              variant="h5"
              component="h1"
            >
              Location
            </Typography>
          </Grid>
          <Grid item sx={{ display: "flex", flexDirection: "row" }}>
            <Typography className="textcolorBule">Setting</Typography>
            <Typography>
              <span>&nbsp;</span> / Create Location
            </Typography>
          </Grid>
        </Grid>

        <TabContext value={value}>
          <TabList
            variant="scrollable"
            scrollButtons="auto"
            onChange={handleChange}
            TabIndicatorProps={{ style: { backgroundColor: "transparent" } }}
          >
            <Tab
              sx={{
                "&.Mui-selected": {
                  background: "#80C340",
                  color: "white",
                  borderTopLeftRadius: "15px",
                  borderTopRightRadius: "15px",
                },
              }}
              label="Information"
              value="1"
            />
            <Tab
              sx={{
                "&.Mui-selected": {
                  background: "#80C340",
                  color: "white",
                  borderTopLeftRadius: "15px",
                  borderTopRightRadius: "15px",
                },
              }}
              label="Employee"
              value="3"
            />
            {/* <Tab
                            sx={{
                                "&.Mui-selected": {
                                    background: "#80C340",
                                    color: "white",
                                    borderTopLeftRadius: "15px",
                                    borderTopRightRadius: "15px",
                                },
                            }}
                            label="Container Yard"
                            value="2"
                        /> */}
          </TabList>
          <Divider />
          <TabPanel value="1">
            <Formik
              enableReinitialize
              initialValues={{
                LocationId: id,
                CountryId: locationData?.CountryId
                  ? locationData?.CountryId
                  : "",
                LocationName: locationData?.LocationName,
                LocationCode: locationData?.LocationCode,
                VoyCode: locationData?.VoyCode,
                MAC5ShipCode: locationData?.MAC5ShipCode,
                MAC5TrainCode: locationData?.MAC5TrainCode,
                MAC5TruckCode: locationData?.MAC5TruckCode,
                Status: locationData?.Status === true ? 1 : 0,
              }}
              onSubmit={(values, { setSubmitting }) => {
                setTimeout(() => {
                  const body = {
                    LocationId: values?.LocationId,
                    CountryId: values?.CountryId,
                    LocationName: values?.LocationName,
                    LocationCode: values?.LocationCode,
                    VoyCode: values?.VoyCode,
                    MAC5ShipCode: values?.MAC5ShipCode,
                    MAC5TrainCode: values?.MAC5TrainCode,
                    MAC5TruckCode: values?.MAC5TruckCode,
                    LocationCostDetails: rows,
                  };

                  api
                    .post("api/location/update", body)
                    .then((respose) => {
                      Swal.fire({
                        text: `${respose.meta.message}`,
                        icon: "success",
                        confirmButtonColor: "#3085d6",
                        confirmButtonText: "OK",
                      }).then((result) => {
                        if (result.isConfirmed) {
                          history.push("/Setting/Location");
                        }
                      });
                    })
                    .catch((err) => {
                      console.log(err);
                    });

                  setSubmitting(false);
                }, 400);
              }}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                /* and other goodies */
              }) => (
                <form onSubmit={handleSubmit} style={{ margin: "20px" }}>
                  <Grid container>
                    <Grid item xs={12} md={12}>
                      <FormControl
                        fullWidth
                        required
                        classes={{
                          root: !values.CountryId
                            ? classes.customOutline
                            : null,
                        }}
                      >
                        <InputLabel sx={{ top: "10px" }}>Country</InputLabel>
                        <Select
                          name="CountryId"
                          value={values.CountryId}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          label="Country"
                          style={{
                            width: "50%",
                            marginTop: "10px",
                            marginBottom: "10px",
                          }}
                        >
                          {countryData?.map((option) => {
                            return (
                              <MenuItem
                                key={option?.CountryId}
                                value={option?.CountryId}
                              >
                                {option?.CountryName}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} md={12} sx={{ marginTop: "10px" }}>
                      <TextField
                        name="LocationName"
                        label="Location Name"
                        variant="outlined"
                        required
                        placeholder="Location Name"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        style={{ width: "50%", marginRight: 5 }}
                        InputLabelProps={{ shrink: true }}
                        value={values.LocationName}
                        classes={{
                          root: !values.LocationName
                            ? classes.customOutline
                            : null,
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} md={12} sx={{ marginTop: "10px" }}>
                      <TextField
                        name="LocationCode"
                        label="Location Code"
                        variant="outlined"
                        required
                        placeholder="Location Code"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        style={{ width: "50%", marginRight: 5 }}
                        InputLabelProps={{ shrink: true }}
                        value={values.LocationCode}
                        classes={{
                          root: !values.LocationCode
                            ? classes.customOutline
                            : null,
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} md={12} sx={{ marginTop: "10px" }}>
                      <TextField
                        name="VoyCode"
                        label="Voy Code"
                        variant="outlined"
                        required
                        placeholder="Voy Code"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        style={{ width: "50%", marginRight: 5 }}
                        InputLabelProps={{ shrink: true }}
                        value={values.VoyCode}
                        classes={{
                          root: !values.VoyCode ? classes.customOutline : null,
                        }}
                      />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      md={12}
                      sx={{ marginTop: "10px", marginBottom: "20px" }}
                    >
                      <TextField
                        name="MAC5ShipCode"
                        label="MAC-5 Ship Code"
                        variant="outlined"
                        required
                        placeholder="MAC-5 Ship Code"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        style={{ width: "50%", marginRight: 5 }}
                        InputLabelProps={{ shrink: true }}
                        value={values.MAC5ShipCode}
                      />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      md={12}
                      sx={{ marginTop: "10px", marginBottom: "20px" }}
                    >
                      <TextField
                        name="MAC5TrainCode"
                        label="MAC-5 Train Code"
                        variant="outlined"
                        required
                        placeholder="MAC-5 Train Code"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        style={{ width: "50%", marginRight: 5 }}
                        InputLabelProps={{ shrink: true }}
                        value={values.MAC5TrainCode}
                      />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      md={12}
                      sx={{ marginTop: "10px", marginBottom: "20px" }}
                    >
                      <TextField
                        name="MAC5TruckCode"
                        label="MAC-5 Truck Code"
                        variant="outlined"
                        required
                        placeholder="MAC-5 Truck Code"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        style={{ width: "50%", marginRight: 5 }}
                        InputLabelProps={{ shrink: true }}
                        value={values.MAC5TruckCode}
                      />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      md={12}
                      sx={{ marginTop: "10px", marginBottom: "20px" }}
                    >
                      <FormControl fullWidth>
                        <InputLabel>Status</InputLabel>
                        <Select
                          name="Status"
                          id="select_status"
                          value={values.Status}
                          label="Status"
                          style={{
                            width: "50%",
                          }}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        >
                          <MenuItem value={1}>Active</MenuItem>
                          <MenuItem value={0}>InActive</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                  <Button
                    type="button"
                    variant="contained"
                    // disabled={costType ? false : true}
                    style={{
                      background: "#80c340",
                      borderColor: "#80c340",
                      marginTop: "10px",
                    }}
                    onClick={addRow}
                  >
                    <AddIcon /> Add
                  </Button>
                  <TableContainer sx={{ marginTop: 2, marginBottom: 2 }}>
                    <Table stickyHeader>
                      <TableRow>
                        <TableCell align="center" width="5%">
                          #
                        </TableCell>
                        <TableCell align="center" width="15%">
                          Charge
                        </TableCell>
                        <TableCell align="center" width="10%">
                          Quantity
                        </TableCell>
                        <TableCell align="center" width="15%">
                          Price
                        </TableCell>
                        <TableCell align="center" width="10%">
                          Currency
                        </TableCell>

                        {/* <TableCell align="center" width="15%">TaxTotal</TableCell> */}
                        <TableCell align="center" width="10%"></TableCell>
                      </TableRow>
                      {rows?.map((data, index) => {
                        return (
                          <TableBody key={index}>
                            <TableCell align="center">{index + 1}</TableCell>
                            <TableCell align="center">
                              {/* <FormControl fullWidth>
                        <InputLabel>Charge</InputLabel>
                        <Select
                          label="Charge"
                          value={data?.CostId || ''}
                          InputLabelProps={{ shrink: true }}
                          onChange={(e) => {
                            const io = rows?.map((v) => {
                              v.CostId =
                                v?.id === data?.id ? e.target.value : v?.CostId;
                              v.Cost =
                                v?.id === data?.id ? MasterCost.find(x => x?.CostId === e.target.value) : v?.Cost;
                              v.CostPrice =
                                v?.id === data?.id ? MasterCost.find(x => x?.CostId === e.target.value)?.CostPrice : +v?.CostPrice;
                              v.CurrencyId =
                                v?.id === data?.id ? MasterCost.find(x => x?.CostId === e.target.value)?.CurrencyId : v?.CurrencyId;

                              return v;
                            });

                            setRows([...io]);
                          }}
                        >
                          {MasterCost?.map((x) =>
                            <MenuItem value={x?.CostId}>{x?.CostName}</MenuItem>
                          )}
                        </Select>
                      </FormControl> */}
                              <Autocomplete
                                // freeSolo
                                fullWidth
                                options={MasterCost}
                                getOptionLabel={(option) => option?.CostName}
                                // renderOption={(props, option) => (
                                //   <Box component="li" {...props} key={option.EmpNo}>
                                //     {option?.firstname} {option?.lastname}</Box>
                                // )}

                                id="controlled-demo"
                                value={data?.Cost}
                                onChange={(event, newValue) => {
                                  const io = rows?.map((v) => {
                                    v.Cost =
                                      v?.id === data?.id ? newValue : v?.Cost;
                                    v.CostId =
                                      v?.id === data?.id
                                        ? newValue?.CostId
                                        : v?.CostId;
                                    v.Cost =
                                      v?.id === data?.id
                                        ? MasterCost.find(
                                            (x) =>
                                              x?.CostId === newValue?.CostId
                                          )
                                        : v?.Cost;
                                    v.CostPrice =
                                      v?.id === data?.id
                                        ? MasterCost.find(
                                            (x) =>
                                              x?.CostId === newValue?.CostId
                                          )?.CostPrice
                                        : +v?.CostPrice;
                                    v.CurrencyId =
                                      v?.id === data?.id
                                        ? MasterCost.find(
                                            (x) =>
                                              x?.CostId === newValue?.CostId
                                          )?.CurrencyId
                                        : v?.CurrencyId;

                                    return v;
                                  });

                                  setRows([...io]);
                                }}
                                selectOnFocus
                                clearOnBlur
                                handleHomeEndKeys
                                renderInput={(params) => (
                                  <TextField {...params} label="Charge" />
                                )}
                              />
                            </TableCell>

                            <TableCell align="center">
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={data?.CostPerContainer || ""}
                                    onChange={(e) => {
                                      const io = rows?.map((v) => {
                                        v.CostPerContainer =
                                          v?.id === data?.id
                                            ? e.target.checked
                                            : v?.CostPerContainer;

                                        return v;
                                      });

                                      setRows([...io]);
                                    }}
                                  />
                                }
                                label="per CNTR"
                              />
                            </TableCell>
                            <TableCell align="center">
                              <TextField
                                label="Price"
                                value={data?.CostPrice || ""}
                                type="number"
                                onChange={(e) => {
                                  const io = rows?.map((v) => {
                                    v.CostPrice =
                                      v?.id === data?.id
                                        ? +e.target.value
                                        : +v?.CostPrice;

                                    return v;
                                  });

                                  setRows([...io]);
                                }}
                              />
                            </TableCell>
                            <TableCell align="center">
                              <FormControl fullWidth>
                                <InputLabel>Currency</InputLabel>
                                <Select
                                  label="Currency"
                                  value={data?.CurrencyId || ""}
                                  InputLabelProps={{ shrink: true }}
                                  onChange={(e) => {
                                    const io = rows?.map((v) => {
                                      v.CurrencyId =
                                        v?.id === data?.id
                                          ? e.target.value
                                          : v?.CurrencyId;

                                      return v;
                                    });

                                    setRows([...io]);
                                  }}
                                >
                                  {currency?.map((x) => (
                                    <MenuItem value={x?.CurrencyId}>
                                      {x?.CurrencyCode}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </TableCell>

                            <TableCell align="center">
                              <Button
                                type="button"
                                variant="outlined"
                                style={{
                                  color: "#80c340",
                                  borderColor: "#80c340",
                                }}
                                onClick={() => deletehand(index)}
                              >
                                Delete
                              </Button>
                            </TableCell>
                          </TableBody>
                        );
                      })}
                    </Table>
                  </TableContainer>
                  <Button
                    type="button"
                    variant="outlined"
                    style={{
                      color: "#80c340",
                      borderColor: "#80c340",
                      marginRight: "10px",
                    }}
                    onClick={history.goBack}
                  >
                    back
                  </Button>
                  <Button
                    type="submit"
                    variant="contained"
                    style={{
                      background: "#80c340",
                      borderColor: "#80c340",
                      marginRight: "10px",
                    }}
                    disabled={isSubmitting}
                  >
                    {isSubmitting && <CircularProgress size={22} />}
                    {!isSubmitting && "SAVE"}
                  </Button>
                </form>
              )}
            </Formik>
          </TabPanel>
          <TabPanel value="3">
            <LocationEmployeeTab locationId={id} />
          </TabPanel>
          <TabPanel value="2">
            <div style={{ display: "flex", float: "right" }}>
              <Button
                style={{
                  backgroundColor: "#80C340",
                  color: "white",
                  textTransform: "none",
                }}
                onClick={handleClickOpen}
              >
                <span className="material-icons-outlined">add</span>
                Add Container Yard
              </Button>
            </div>
            <div>
              {!FoundStatus && (
                <h6 style={{ marginTop: "10px" }} className="textcolordarkblue">
                  ไม่พบข้อมูล Container Yard
                </h6>
              )}

              {FoundStatus &&
                CYData?.map((item, i) => (
                  <div key={i}>
                    <Formik
                      enableReinitialize={true}
                      initialValues={{
                        ContainerYardId: item?.ContainerYardId,
                        LocationId: id,
                        ContainerYardZoneNo: item?.ContainerYardZoneNo,
                        ContainerYardZoneName: item?.ContainerYardZoneName,
                        BayCount: item?.BayCount,
                        RowCount: item?.RowCount,
                        TireCount: item?.TireCount,
                        Remark: item?.Remark,
                        Status: item?.Status,
                      }}
                      onSubmit={(values, { setSubmitting }) => {
                        setTimeout(() => {
                          const MySwal = withReactContent(Swal);
                          MySwal.fire({
                            title: "Confirm Save?",
                            text: "I agree to save the data!",
                            icon: "info",
                            showCancelButton: true,
                            confirmButtonColor: "#3085d6",
                            cancelButtonColor: "#d33",
                            confirmButtonText: "Yes !",
                          }).then((result) => {
                            if (result.isConfirmed) {
                              api
                                .post(
                                  "api/location/containeryard/update",
                                  values
                                )
                                .then((respose) => {
                                  MySwal.fire(
                                    "Success!",
                                    "Edit  Success.",
                                    "success"
                                  );

                                  setValue("2");
                                  FetchCY();

                                  // console.log(respose);
                                })
                                .catch((err) => {
                                  MySwal.fire(
                                    "Error!",
                                    "Can't Saved Factory Please Check Data.",
                                    "error"
                                  );
                                  setValue("2");
                                  console.log(err);
                                });
                            }
                          });

                          setSubmitting(false);
                        }, 400);
                      }}
                    >
                      {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting,

                        /* and other goodies */
                      }) => (
                        <form
                          onSubmit={handleSubmit}
                          style={{ margin: "20px" }}
                        >
                          <Grid container>
                            <Grid item xs={12} md={12}>
                              <div style={{ display: "flex", marginTop: 10 }}>
                                <TextField
                                  name="ContainerYardZoneNo"
                                  label="ContainerYardZoneNo"
                                  variant="outlined"
                                  placeholder="ContainerYardZoneNo"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  style={{ width: "50%", marginRight: 5 }}
                                  InputLabelProps={{ shrink: true }}
                                  value={values.ContainerYardZoneNo}
                                  disabled={!item?.disabled}
                                />

                                <TextField
                                  name="ContainerYardZoneName"
                                  label="ContainerYardZoneName."
                                  variant="outlined"
                                  placeholder="ContainerYardZoneName"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  style={{ width: "25%", marginRight: 5 }}
                                  InputLabelProps={{ shrink: true }}
                                  value={values.ContainerYardZoneName}
                                  disabled={!item?.disabled}
                                />

                                <FormControl
                                  style={{
                                    width: "25%",
                                  }}
                                >
                                  <InputLabel id="select_status-label">
                                    Status
                                  </InputLabel>
                                  <Select
                                    name="Status"
                                    value={values.Status}
                                    label="Status"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    disabled={!item?.disabled}
                                  >
                                    <MenuItem value={true}>Active</MenuItem>
                                    <MenuItem value={false}>InActive</MenuItem>
                                  </Select>
                                </FormControl>
                              </div>
                              <div style={{ display: "flex", marginTop: 10 }}>
                                <TextField
                                  name="BayCount"
                                  label="Bay"
                                  variant="outlined"
                                  placeholder="Bay"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  style={{ width: "50%", marginRight: 5 }}
                                  InputLabelProps={{ shrink: true }}
                                  value={values.BayCount}
                                  disabled={!item?.disabled}
                                />

                                <TextField
                                  name="RowCount"
                                  label="Row"
                                  variant="outlined"
                                  placeholder="Row"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  style={{ width: "25%", marginRight: 5 }}
                                  InputLabelProps={{ shrink: true }}
                                  value={values.RowCount}
                                  disabled={!item?.disabled}
                                />

                                <TextField
                                  name="TireCount"
                                  label="Tires"
                                  variant="outlined"
                                  placeholder="Tires"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  style={{ width: "25%", marginRight: 5 }}
                                  InputLabelProps={{ shrink: true }}
                                  value={values.TireCount}
                                  disabled={!item?.disabled}
                                />
                              </div>
                              <div style={{ display: "flex", marginTop: 10 }}>
                                <TextField
                                  name="Remark"
                                  label="Remark"
                                  variant="outlined"
                                  placeholder="Remark"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  style={{ width: "75%", marginRight: 5 }}
                                  InputLabelProps={{ shrink: true }}
                                  value={values.Remark}
                                  disabled={!item?.disabled}
                                />

                                <Button
                                  type="button"
                                  variant="contained"
                                  size="small"
                                  style={{
                                    color: "white",
                                    borderColor: "#FFA101",
                                    background: "#FFA101",
                                    marginRight: "10px",
                                    textTransform: "none",
                                  }}
                                  onClick={() => handleDisable(i)}
                                >
                                  Edit
                                </Button>
                                {item?.disabled && (
                                  <Button
                                    type="submit"
                                    variant="contained"
                                    style={{
                                      background: "#80c340",
                                      borderColor: "#80c340",
                                      marginRight: "10px",
                                      textTransform: "none",
                                    }}
                                    disabled={isSubmitting}
                                  >
                                    {isSubmitting && (
                                      <CircularProgress size={22} />
                                    )}
                                    {!isSubmitting && "SAVE"}
                                  </Button>
                                )}
                              </div>
                            </Grid>
                          </Grid>
                        </form>
                      )}
                    </Formik>
                    <hr />
                  </div>
                ))}
            </div>
          </TabPanel>
        </TabContext>
      </Card>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Add Container Yard</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Please complete the information. and check before confirming .
          </DialogContentText>

          <TextField
            label="CY Zone No"
            onChange={(e) => setContainerYardZoneNo(e.target.value)}
            value={containerYardZoneNo}
            fullWidth
            variant="outlined"
            sx={{ marginBottom: "10px", marginTop: "10px" }}
          />
          <TextField
            label="CY Zone Name"
            onChange={(e) => setContainerYardZoneName(e.target.value)}
            value={containerYardZoneName}
            fullWidth
            variant="outlined"
            sx={{ marginBottom: "10px" }}
          />

          <TextField
            label="Remark"
            fullWidth
            variant="outlined"
            onChange={(e) => setRemark(e.target.value)}
            value={remark}
            sx={{ marginBottom: "10px" }}
          />
          <div style={{ display: "flex" }}>
            <TextField
              label="Bay"
              fullWidth
              variant="outlined"
              onChange={(e) => setBayCount(e.target.value)}
              value={bayCount}
              sx={{ marginRight: "10px" }}
            />
            <TextField
              label="Row"
              fullWidth
              variant="outlined"
              onChange={(e) => setRowCount(e.target.value)}
              value={rowCount}
              sx={{ marginRight: "10px" }}
            />
            <TextField
              label="Tires"
              fullWidth
              variant="outlined"
              onChange={(e) => setTireCount(e.target.value)}
              value={tireCount}
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button
            onClick={() => {
              const body = {
                ContainerYardId: null,
                LocationId: id,
                ContainerYardZoneNo: containerYardZoneNo,
                ContainerYardZoneName: containerYardZoneName,
                BayCount: bayCount,
                RowCount: rowCount,
                TireCount: tireCount,
                Remark: remark,
                Status: true,
              };
              api
                .post("api/location/containeryard/create", body)
                .then((respose) => {
                  setOpen(false);

                  Swal.fire({
                    title: `${respose.meta.message}`,
                    icon: "success",
                    confirmButtonColor: "#3085d6",
                    confirmButtonText: "OK",
                  }).then((result) => {
                    if (result.isConfirmed) {
                      FetchCY();
                    }
                  });
                })
                .catch((err) => {
                  console.log(err);
                });
            }}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
